import GlyphIcon from "./GlyphIcon.mjs";

/**
 * Glyphicon 577-cluster
 * @see {GlyphIcon}
 */
const ClusterIcon = class extends GlyphIcon {
	constructor(props) {
		super(props);
		this.state.d="M28,25a3.00008,3.00008,0,1,1-5.70007-1.286L18.286,19.70007a2.90061,2.90061,0,0,1-2.72656-.08392l-4.7854,4.24774a3.06364,3.06364,0,1,1-1.34143-1.48431l4.79059-4.25232A2.98455,2.98455,0,0,1,14,17c0-.04047.01031-.07806.0119-.1181L9.24268,14.97424A2.98671,2.98671,0,1,1,10,13c0,.04047-.01031.07806-.0119.1181l4.76922,1.90766a2.99969,2.99969,0,0,1,.47467-.4386L13.85138,9.985A2.9991,2.9991,0,1,1,15.768,9.41284L17.14862,14.015a2.97136,2.97136,0,0,1,1.13739.28492L22.29993,10.286A3.02843,3.02843,0,1,1,23.714,11.70007L19.70007,15.714a2.907,2.907,0,0,1,0,2.572L23.714,22.29993A2.98246,2.98246,0,0,1,28,25Z";
	}
}

export default ClusterIcon;
